import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { LinkedInImportProfileForm } from '../../features/loginWithLinkedIn/LinkedInImportProfileForm/LinkedInImportProfileForm.js';
import { LoginForm } from '../../../views/Login/index.js';
import { RegistrationForm } from '../../../views/Registration/index.js';
import { ResetPasswordForm } from '../../../views/ResetPassword/index.js';
export const modalFormConfigs = () => {
    return [
        {
            component: LoginForm,
            type: FORM_TYPES.LOGIN,
        },
        {
            component: RegistrationForm,
            type: FORM_TYPES.REGISTRATION,
        },
        {
            component: ResetPasswordForm,
            type: FORM_TYPES.RESET_PASSWORD,
        },
        {
            component: LinkedInImportProfileForm,
            type: FORM_TYPES.LINKEDIN_IMPORT_PROFILE,
        },
    ];
};
//# sourceMappingURL=modalFormConfigs.js.map